import styled from 'styled-components';

export const RecipeTypeDescription = styled.div`
  font-size: 0.7em;
  color: gray;
`;

export const RecipeIdentification = styled.div`
  font-weight: bold;
`;

export const RecipeFileBlock = styled.div`
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  text-align: center;
  background-color: #fff9f9;
`;

export const DiagnosticBlock = styled.div`
  margin-bottom: 10px;
`;

export const DiagnosticDistanceType = styled.div`
  padding-bottom: 5px;
`;

export const DiagnosticContainerTable = styled.div`
  margin-bottom: 10px;
`;

export const ConfirmationBlock = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  color: gray;
`;